import React from "react";
import { GripVertical, Trash2 } from "lucide-react";
import QuestionPreview from "./QuestionPreview";

export default function SelectedQuestionItem({
  question,
  position,
  onRemove,
  canDrag,
  dragging,
  dragOver,
  onDragStart,
  onDragOver,
  onDragLeave,
  onDrop,
  onDragEnd,
}) {
  const removeAction = onRemove ? (
    <button type="button" className="danger" onClick={() => onRemove(question.questionId)} aria-label="Remover questão">
      <Trash2 size={14} aria-hidden="true" />
    </button>
  ) : null;

  return (
    <div
      className={[
        "teacher-mocks-draggable-question",
        canDrag ? "can-drag" : "",
        dragging ? "dragging" : "",
        dragOver ? "drag-over" : "",
      ].filter(Boolean).join(" ")}
      draggable={false}
      onDragOver={onDragOver}
      onDragLeave={onDragLeave}
      onDrop={onDrop}
    >
      {canDrag && (
        <span
          className="teacher-mocks-drag-handle"
          aria-label="Arrastar questão"
          title="Arrastar questão"
          draggable
          onDragStart={onDragStart}
          onDragEnd={onDragEnd}
        >
          <GripVertical size={16} aria-hidden="true" />
        </span>
      )}
      <QuestionPreview
        question={{
          id: question.questionId,
          context: question.context,
          firstStemContent: question.firstStemContent,
          difficultyLevel: question.difficultyLevel,
          cognitiveLevel: question.cognitiveLevel,
          format: question.format,
        }}
        prefix={`${position}.`}
        action={removeAction}
      />
    </div>
  );
}
